import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, MatComponentsModule, ResizeService } from '@thehubz/client/core';
import { AssetBulkEditComponent } from './components/asset-bulk-edit/asset-bulk-edit.component';
import { AssetViewComponent } from './components/asset-detail-view/asset-info/components/asset-view/asset-view.component';
import { ClientAssetsDetailViewModule } from './components/asset-detail-view/assets-detail-view.module';
import { AssetDownloadComponent } from './components/asset-download/asset-download.component';
import { AssetGalleryViewComponent } from './components/asset-gallery-view/asset-gallery-view.component';
import { AssetListViewComponent } from './components/asset-listview/asset-listview.component';
import { AssetDashboardKeywordsComponent } from './components/assets/asset-dashboard-keywords/asset-dashboard-keywords.component';
import { AssetDashboardCardViewComponent } from './components/assets/asset-dashboard-view/asset-dashboard-card-view/asset-dashboard-card.component';
import { AssetDashboardViewComponent } from './components/assets/asset-dashboard-view/asset-dashboard-view.component';
import { AssetsSidebarComponent } from './components/assets/assets-sidebar/assets-sidebar.component';
import { CollectionsModule } from './components/collections/collections.module';
import { UploadVariantsComponent } from './components/upload-variants/upload-variants.component';
import { AssetPublishingMessagePipe } from './pipes/asset-publishing-message.pipe';
import { AssetTypeToIconNamePipe } from './pipes/asset-type-to-icon-name/asset-type-to-icon-name.pipe';
import { AssetTypeTranslationPipe } from './pipes/asset-type-translation/asset-type-translation.pipe';
import { CustomTitleCasePipe } from './pipes/custom-title-case.pipe';
import { AssetFiltersService } from './services/asset-filters.service';
import { ProductBrandSelectionService } from './services/product-brand-selection.service';

@NgModule({
  imports: [
    CommonModule,
    MatComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    UiKitModule,
    ClientCoreModule,
    FontAwesomeModule,
    ClientAssetsDetailViewModule,
    CollectionsModule,
    AssetPublishingMessagePipe,
    AssetBulkEditComponent,
    AssetGalleryViewComponent,
    AssetListViewComponent,
    AssetsSidebarComponent,
    RouterModule,
    AssetTypeToIconNamePipe,
    AssetTypeTranslationPipe,
    CustomTitleCasePipe,
    AssetViewComponent,
  ],
  declarations: [
    UploadVariantsComponent,
    AssetDownloadComponent,
    AssetDashboardViewComponent,
    AssetDashboardCardViewComponent,
    AssetDashboardKeywordsComponent,
  ],
  providers: [ResizeService, ProductBrandSelectionService, AssetFiltersService],
  exports: [AssetDownloadComponent, AssetDashboardViewComponent, AssetDashboardKeywordsComponent],
})
export class ClientAssetsModule {}
